var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    style: (("width: " + _vm.width + "px;" + (_vm.rootstyle||'')))
  }, _vm._l((_vm.columns), function(item, index) {
    return (!item.hide) ? _c('div', {
      key: index,
      staticClass: "flex",
      style: ('min-width: ' + item.width + 'px;color: #aaa;padding-right: 10px;')
    }, [_c('div', [_c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.label) ? _c('div', {
      staticStyle: {
        "line-height": "1",
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(item.label))]) : _vm._e()]), _vm._v(" "), (item.tip) ? _c('PageTooltip', {
      attrs: {
        "content": item.tip,
        "width": 300,
        "name": '',
        "placement": 'top-start'
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 0)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0984b45b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CustomTableColumns.vue
// module id = oGK6
// module chunks = 142